export const INFOGRAPHIC_LIST = "INFOGRAPHIC_LIST";
export const INFOGRAPHIC_DETAILS = "INFOGRAPHIC_DETAILS";